import { render, staticRenderFns } from "./tree-node.vue?vue&type=template&id=63c856b8&scoped=true&"
import script from "./tree-node.vue?vue&type=script&lang=ts&"
export * from "./tree-node.vue?vue&type=script&lang=ts&"
import style0 from "./tree-node.vue?vue&type=style&index=0&id=63c856b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c856b8",
  null
  
)

export default component.exports